import { Container } from "react-bootstrap";
import { useAccount } from "@azure/msal-react";
import LoadingSection from "../../atoms/loadingsection/LoadingSection";
import ProjectList from "./projectlist/ProjectList";
import { useGetApiProjects } from "../../../api/generated/endpoints/project/project";
import type { ProjectListItemDto } from "../../../api/generated/model";
import { PROJECT_LIST_QUERY_OPTIONS } from "./projectListQueryOptions";

const MyProjects: React.FC = () => {
  const activeAccount = useAccount();
  const { data: projects, error: projectsError, status: projectsStatus, isFetching: isProjectsLoading, refetch } = useGetApiProjects({
    query: PROJECT_LIST_QUERY_OPTIONS,
  });

  const refetchProjects = async () => {
    refetch();
  }

  if (projectsStatus === "pending"){ return <LoadingSection text="Laddar.." /> }
  if (projectsStatus === "error") { return <div>Error loading projects: {projectsError?.message}</div> };

  const filteredProjects = Array.isArray(projects?.listOfProjectDto) ? projects?.listOfProjectDto?.filter((project: ProjectListItemDto) => 
    project.teamLeader === activeAccount?.name
  ) : [];

  return(
    <Container className="">
      <ProjectList
        loading={isProjectsLoading}
        key={JSON.stringify(projects?.listOfProjectDto)}
        title="Mina projekt"
        listOfProjectDto={filteredProjects}
        refetchProjects={refetchProjects}
        baseUrl="/myProjects"
      />
      </Container>
  )
}

export default MyProjects;